import script from "./CrudArticulos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudArticulos.vue?vue&type=script&setup=true&lang=js"

import "./CrudArticulos.vue?vue&type=style&index=0&id=29186411&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29186411"]])

export default __exports__